// A People record matches the symptom filter only when it is sick and carries EVERY selected
// symptom (the selections AND together, so "Dizziness + Nausea" keeps only reports with both).
// Keep this pure so the map's filtering contract is independently testable.
export function peopleRecordMatchesSymptoms(record, symptoms) {
  const targets = (Array.isArray(symptoms) ? symptoms : [symptoms])
    .filter((value) => typeof value === "string" && value)
    .map((value) => value.toLowerCase());
  if (targets.length === 0) return true;
  if (record?.status !== "sick") return false;
  const owned = new Set(
    (Array.isArray(record.symptoms) ? record.symptoms : []).map((value) => String(value).toLowerCase())
  );
  return targets.every((target) => owned.has(target));
}
